import React from "react";
import { Outlet } from "react-router-dom";

const PaymentLayout: React.FunctionComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default PaymentLayout;
